import { EmployerOrHealthPlanVerificationScreen } from '@/components/EmployerOrHealthPlanVerificationScreen';

export default function EmployerOrHealthPlanVerification() {
  return <EmployerOrHealthPlanVerificationScreen />;
}
